module.exports = __webpack_public_path__ + "static/media/image3.a82e511a.jpg";